module.exports = __webpack_public_path__ + "static/media/star.80932a48.svg";